module.exports = __webpack_public_path__ + "img/video-player/volume-2-e39b2792d46b9f9d0d44b65aca4dd161.svg";